// Supports User Timing and Performance Timeline APIs that we use to measure performance
const canUsePerfAPIs = typeof performance !== 'undefined' && ['mark', 'measure', 'getEntriesByName'].every(method => typeof performance[method] === 'function');
function readPerfDebugFlag() {
  try {
    return localStorage.getItem('QUARTZ_PERF_DEBUG') !== null;
  } catch (_unused) {
    return false;
  }
}
let perfDebugEnabled = readPerfDebugFlag();
export function resetPerfDebugForTesting() {
  perfDebugEnabled = readPerfDebugFlag();
}
export const getEntriesByName = (name, type) => {
  if (canUsePerfAPIs) {
    return performance.getEntriesByName(name, type);
  }
  return [];
};
export const mark = name => {
  if (canUsePerfAPIs) {
    performance.mark(name);
  }
};
export const measure = (name, startMark, endMark) => {
  if (canUsePerfAPIs) {
    try {
      performance.measure(name, startMark, endMark);
      if (perfDebugEnabled) {
        const entries = performance.getEntriesByName(name, 'measure');
        const entry = entries[entries.length - 1];
        if (entry) {
          // eslint-disable-next-line no-console
          console.log(`[quartz perf] ${name}: ${entry.duration.toFixed(2)}ms`);
        }
      }
    } catch (_unused2) {
      // `performance.measure()` can throw but shouldn't in our case
    }
  }
};
export const clearMarks = name => {
  if (canUsePerfAPIs && !perfDebugEnabled) {
    performance.clearMarks(name);
  }
};
export const clearMeasures = name => {
  if (canUsePerfAPIs && !perfDebugEnabled) {
    performance.clearMeasures(name);
  }
};
if (typeof window !== 'undefined' && perfDebugEnabled) {
  window.quartz_perf_logs = () => {
    if (!canUsePerfAPIs) return [];
    return performance.getEntries().filter(e => e.name.indexOf('granite.') === 0 || e.name.indexOf('quartz.') === 0);
  };
}